import { render, staticRenderFns } from "./TagItem.vue?vue&type=template&id=02200e40&scoped=true&"
import script from "./TagItem.vue?vue&type=script&lang=js&"
export * from "./TagItem.vue?vue&type=script&lang=js&"
import style0 from "./TagItem.vue?vue&type=style&index=0&id=02200e40&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02200e40",
  null
  
)

export default component.exports